import {Tooltip} from "@mui/material";
import {Close} from "@mui/icons-material";
import * as React from "react";

const InviteNotSentToCustomerIcon = ({person}) => {
    return (
        <>
            {
                person?.hasOwnProperty("invite_sent") && person.invite_sent <= 0 &&
                <Tooltip title="Invitation not sent yet">
                    <Close sx={{color: "red", fontSize: '20px'}}/>
                </Tooltip>
            }
        </>
    )
}

export default InviteNotSentToCustomerIcon;